













import { Component, Mixins, Prop } from "vue-property-decorator";
import { Rectangle } from "../../../../domain/drawing";
import { IDrawableItem } from "../../../../domain/document/items";

@Component({
})
export default class GeometryViewer extends Mixins() {
  @Prop()
  source: IDrawableItem;

  get rectangle(): Rectangle {
    return (!this.source || !this.source.geometry || !this.source.geometry.rectangle)
      ? null
      : this.source.geometry.rectangle;
  }

  get topLeft(): string {
    return (!this.rectangle || !this.rectangle.topLeft)
      ? "--"
      : "(" + Math.floor(this.rectangle.topLeft.x) + "," + Math.floor(this.rectangle.topLeft.y) + ")";
  }

  get size(): string {
    return (!this.rectangle || !this.rectangle.size)
      ? "--"
      : Math.floor(this.rectangle.size.width) + "x" + Math.floor(this.rectangle.size.height);
  }
}
